import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import 'datatables.net'
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { CustomerEditViewModel } from '@app/models/CustomerEditViewModel';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../../../services/authentication.service';
import { DatatableDefaultOptions } from '../../../DatatableDefaultOptions';
import { UserProfileDataTableViewModel } from '../../../models/UserProfileDataTableViewModel';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesRequest } from '../../../models/DataTablesRequest';
import { DataTablesResponse } from '../../../models/DataTablesResponse';

@Component({
    selector: 'app-users-datatable',
    templateUrl: './users-datatable.component.html',
    styleUrls: ['./users-datatable.component.css']
})
export class UsersDatatableComponent implements OnInit {

    constructor(
        public ngxSmartModalService: NgxSmartModalService,
        private router: Router,
        private http: HttpClient,
        private auth: AuthenticationService,
        private dataTableOptions: DatatableDefaultOptions
    ) { }

    @ViewChild(DataTableDirective)
    private datatableElement: DataTableDirective;
    userDtOptions: DataTables.Settings = {};
    users: UserProfileDataTableViewModel[]
    modalRemove: string = 'userModalRemove'
    modalEdit: string = 'userModalEdit'

    ngOnInit() {
        this.initDatatable();
    }

    ngAfterViewInit() {
        this.reloadDatatableOnModalCloseSuccess(this.modalRemove)
        this.reloadDatatableOnModalCloseSuccess(this.modalEdit)
    }

    reloadDatatableOnModalCloseSuccess(modalName: string) {
        this.ngxSmartModalService.getModal(modalName).onClose.subscribe((modal: NgxSmartModalComponent) => {
            let data = modal.getData()
            if (data && data.success === true) {
                this.reloadDatatable()
            }
        });
    }

    reloadDatatable(): void {
        this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => dtInstance.ajax.reload());
    }

    show(customer: UserProfileDataTableViewModel): void {
        this.router.navigate(['/user/' + customer.id])
    }

    edit(customer: UserProfileDataTableViewModel): void {
        this.http.get<CustomerEditViewModel>("/api/userProfile/update/" + customer.id)
            .subscribe(data => {
                this.ngxSmartModalService.setModalData(data, this.modalEdit);
                this.ngxSmartModalService.open(this.modalEdit);
            });
    }

    remove(customer: UserProfileDataTableViewModel): void {
        this.ngxSmartModalService.setModalData(customer.id, this.modalRemove);
        this.ngxSmartModalService.open(this.modalRemove);
    }

    initDatatable(): void {
        let self = this
        let lastDraw = 0
        this.userDtOptions = {
            ...this.dataTableOptions.defaults, ...{
                ajax: (dataTablesParameters: DataTablesRequest, callback: (data: DataTablesResponse) => any) => {
                    let request = JSON.stringify(dataTablesParameters)
                    this.http.get<DataTablesResponse>(`api/userProfile/Datatable?request=${request}`).subscribe(response => {
                        if (response.draw < lastDraw) {
                            return;
                        }
                        lastDraw = response.draw
                        self.users = response.data;
                        let callbackResponse: DataTablesResponse = {
                            recordsTotal: response.recordsTotal,
                            recordsFiltered: response.recordsFiltered,
                            data: [],
                            draw: 0
                        }
                        callback(callbackResponse);
                    });
                },
            },
            columns: [
                { data: 'userName' },
                { data: 'email' },
                { data: 'employmentNumber' },
                { data: 'firstName' },
                { data: 'lastName' },
                { data: 'phoneNumber' }
            ]
        }
    }
}
